import React from 'react'

import { LIST_ROW } from '@/components/base/listRow'
import { AppContext } from '@/components/base/appcontext'
import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'

import { Loader2 } from 'lucide-react'

/** A pending row: the shape of a real item, the first one spinning. */
function PendingRow({ index, rows }: { index: number; rows: number }) {
    return (
        <div
            style={{ opacity: 1 - (index / rows) * 0.7 }}
            className={cn(LIST_ROW, 'flex items-center gap-3')}
        >
            {index === 0 ? (
                <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-muted text-muted-foreground">
                    <Loader2 className="h-4 w-4 animate-spin motion-reduce:animate-none" />
                </div>
            ) : (
                <Skeleton className="h-9 w-9 shrink-0 rounded-full" />
            )}
            <div className="flex flex-1 min-w-0 flex-col gap-2">
                <Skeleton className="h-3.5 w-2/5" />
                <Skeleton className="h-3 w-3/5" />
            </div>
        </div>
    )
}

/**
 * A list that is fetching: a short stack of pending rows where the items
 * will land, fading out. One row marks the next page at a list's end.
 */
export function ListLoader({
    rows = 3,
    className
}: {
    rows?: number
    className?: string
}) {
    const appContext = React.useContext(AppContext)
    return (
        <div role="status" className={cn('flex flex-col gap-3', className)}>
            <span className="sr-only">{appContext.geti18n('Loading...')}</span>
            {Array.from({ length: rows }, (_, i) => (
                <PendingRow key={i} index={i} rows={rows} />
            ))}
        </div>
    )
}
